import type {AllergenCheckbox, DietCheckbox} from '~/types/foodMenu';

export function getAllergenIds(items: AllergenCheckbox[]): string[] {
	return items
		.filter((i) => i.value || i.indeterminate)
		.flatMap((i) => i.items ? [i.id, getAllergenIds(i.items)] : i.id)
		.flat();
}

export function getDietItems(items: DietCheckbox[]) {
	return items.filter((i) => i.value);
}

export function getDietIconName(type: string) {
	switch (type) {
		case 'bezlepek':
			return 'diet/gluten';
		case 'veganske':
			return 'diet/vegan';
		case 'vegetarianske':
			return 'diet/vegetarian';
		default:
			return '';
	}
}
